import { useToast } from '../../../components/ui/use-toast.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import type { CrmNoteDTO } from '../../../server/dto/crm-note-dto.ts';
import { api } from '../../../utils/api.ts';

export const useUnpinNote = (note: CrmNoteDTO) => {
    const { t } = useLocale('notes');
    const { toast } = useToast();
    const apiUtils = api.useUtils();

    const unpinMutation = api.platoUser.command.notes.unpin.useMutation({
        onSuccess: async () => {
            toast({
                icon: 'success',
                title: t('notes__unpin_success_toast'),
            });

            await Promise.all([
                apiUtils.platoUser.query.customerActivity.getFeedList.getPinnedNotes.invalidate(),
                apiUtils.platoUser.query.customerActivity.getFeedList.withFilters.invalidate(),
                apiUtils.platoUser.query.notes.getNoteById.invalidate({ noteId: note.noteId }),
            ]);
        },
        onError: (error) => {
            toast({
                icon: 'warning',
                title: 'Error',
                description: error.message,
            });
        },
    });

    const unpin = (): void => {
        unpinMutation.mutate({ noteId: note.noteId });
    };

    return {
        unpin,
        isPending: unpinMutation.isPending,
    };
};
